import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("elvis_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setAdminToken(token) {
  if (token) localStorage.setItem("elvis_admin_token", token);
  else localStorage.removeItem("elvis_admin_token");
}

export function getAdminToken() {
  return localStorage.getItem("elvis_admin_token");
}
